import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/CommonModule/Dashboard/dashboard/dashboard.component';
import { UsersComponent } from './pages/CommonModule/Users/users/users.component';
import { RolesComponent } from './pages/CommonModule/Roles/roles/roles.component';
import { LoginComponent } from './login/login.component';
import { FormsComponent } from './pages/CommonModule/Forms/forms/forms.component';
import { ResetpasswordComponent } from './pages/CommonModule/resetpassword/resetpassword.component';
import { BranchesComponent } from './pages/branches/branches.component';
import { OfficesComponent } from './pages/Offices/offices/offices.component';
import { DiretorsComponent } from './pages/Directors/diretors/diretors.component';
import { OfficersComponent } from './pages/Officers/officers/officers.component';
import { HomepagesComponent } from './pages/Homepage/homepages/homepages.component';
import { MasterdetailsComponent } from './pages/MasterDetails/masterdetails/masterdetails.component';
import { ArchivementmastersComponent } from './pages/Achivements/archivementmasters/archivementmasters.component';
import { OrginfosComponent } from './pages/AboutUs/orginfos/orginfos.component';
import { FinancialStatusYears } from './Models/financialstatusyear';
import { FinancialstatusyearsComponent } from './pages/FinancialData/financialstatusyears/financialstatusyears.component';
import { DepositeintrestratesComponent } from './pages/DepositeRates/depositeintrestrates/depositeintrestrates.component';
import { LoansComponent } from './pages/Loans/loans/loans.component';
import { LoanintrestratesComponent } from './pages/LoanRates/loanintrestrates/loanintrestrates.component';
import { DepositesComponent } from './pages/Deposites/deposites/deposites.component';
import { GallarygroupmastersComponent } from './pages/Gallary/gallarygroupmasters/gallarygroupmasters.component';
import { GallerymastersComponent } from './pages/Gallary/gallerymasters/gallerymasters.component';
import { FinancialyeardatasComponent } from './pages/FinancialData/financialyeardatas/financialyeardatas.component';
import { InvestmentsComponent } from './pages/Investments/investments/investments.component';
import { SevicemastersComponent } from './pages/Services/sevicemasters/sevicemasters.component';

export const routes: Routes = [
  {path: 'login', redirectTo: 'login' },
  {path: 'login', component:LoginComponent },
  {path :'dashboard', component:DashboardComponent},
  {path :'users', component:UsersComponent},
  {path :'roles', component:RolesComponent},
  {path :'forms', component:FormsComponent},
  {path :'resetpassword', component:ResetpasswordComponent},
  {path :'branches', component:BranchesComponent},
  {path :'headOffices', component:OfficesComponent},
  {path :'directors', component:DiretorsComponent},
  {path :'officers', component:OfficersComponent},
  {path :'banners', component:HomepagesComponent},
  {path :'address', component:MasterdetailsComponent},
  {path :'achivements', component:ArchivementmastersComponent},
  {path :'aboutus', component:OrginfosComponent},
  {path :'financialYears', component:FinancialstatusyearsComponent},
  {path :'financialData', component:FinancialyeardatasComponent},
  {path :'depositeRates', component:DepositeintrestratesComponent},
  {path :'loans', component:LoansComponent},
  {path :'loanRates', component:LoanintrestratesComponent},
  {path :'deposites', component:DepositesComponent},
  {path :'albums', component:GallarygroupmastersComponent},
  {path :'gallery', component:GallerymastersComponent},
  {path :'investments', component:InvestmentsComponent},
  {path :'services', component:SevicemastersComponent},
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
